import React from 'react'

const bannersRoutes = [
    {
        path: '/banners/cupons',
        exact: true,
        component: React.lazy(() => import('./cupons/lista/CupomTable')),
    },
    {
        path: '/banners/novo',
        exact: true,
        component: React.lazy(() => import('./cadastros/form/Form')),
    },
    {
        path: '/banners/editar',
        exact: true,
        component: React.lazy(() => import('./cadastros/form/Form')),
    },
    {
        path: '/banners',
        exact: true,
        component: React.lazy(() => import('./cadastros/lista/Table')),
    },
    {
        path: '/banners/resgates',
        exact: true,
        component: React.lazy(() => import('./resgates/lista/Table')),
    },
    // Rotas de Anúncios (Vídeos)
    {
        path: '/anuncios/novo',
        exact: true,
        component: React.lazy(() => import('./cadastros/form/Form')),
    },
    {
        path: '/anuncios/editar',
        exact: true,
        component: React.lazy(() => import('./cadastros/form/Form')),
    },
    {
        path: '/anuncios',
        exact: true,
        component: React.lazy(() => import('./cadastros/lista/Table')),
    },
]

export default bannersRoutes
